import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import CT from '@marketplace-ai/tags';
import { ColDef } from 'ag-grid-community';
import { CustomCellRendererProps } from 'ag-grid-react';
import { DeleteCellRenderer, EditCellRenderer } from '~/components/Table/gridUtil';

export const createDelBtnCol = ({
  handleDeleteClick,
}: {
  handleDeleteClick: (args: unknown) => void;
}): ColDef => {
  return {
    field: '',
    colId: 'delete',
    cellRenderer: DeleteCellRenderer,
    cellRendererParams: { onDelete: handleDeleteClick, cyTag: CT.agGrid.deleteBtn },
    width: 25,
    flex: 0,
    cellStyle: { display: 'flex', justifyContent: 'center' },
    editable: false,
    sortable: false,
    filter: false,
  };
};

export const createEditBtnCol = (handleEditClick: (args: unknown) => void): ColDef => {
  return {
    field: '',
    colId: 'edit',
    cellRenderer: EditCellRenderer,
    cellRendererParams: { onEdit: handleEditClick, cyTag: CT.certs.table.editBtn },
    width: 25,
    flex: 0,
    cellStyle: { display: 'flex', justifyContent: 'center' },
    editable: false,
    sortable: false,
    filter: false,
  };
};

export const createValidCol = (): ColDef => {
  return {
    colId: 'validFlag',
    field: 'validFlag',
    maxWidth: 40,
    filter: false,
    sortable: false,
    headerName: '',
    cellRenderer: ({ data }: CustomCellRendererProps) => {
      if (data.validFlag !== false) return null;
      return (
        <div className="flex justify-center h-full items-center" data-cy={CT.agGrid.warningIcon}>
          <ExclamationTriangleIcon className="h-5 w-5 text-warning mr-2" />
        </div>
      );
    },
  };
};
